module.exports = __webpack_public_path__ + "img/search-icon@3x.b7941c43.png";